export default __webpack_public_path__ + "static/img-nhs-optimiser--mobile-edff72b233a6580e4155e80297d39348.webp";